import { MaterialIcons } from "@expo/vector-icons";
import { StyleSheet, Text, View } from "react-native";
import { ThemedTextWithBold, useCustomTheme } from "@luna-restaurant/ui";
import { MenuLabel } from "../MenuCard/MenuLabel";
const isDietaryLabel = (title) => {
    return title === "vegetarian" || title === "fish" || title === "meat";
};
export const DrawerText = ({ title, textContent, icon }) => {
    const { colors, fonts } = useCustomTheme();
    return (<View style={styles.drawerTextContainer}>
      {isDietaryLabel(title) ? (<View style={styles.drawerMenuLabelContainer}>
          <MenuLabel label={title}/>
        </View>) : (<View style={[
                styles.drawerTextIconContainer,
                { backgroundColor: colors.danger },
            ]}>
          {icon && (<MaterialIcons name={icon} size={14} color={colors.background}/>)}
          <Text style={[
                { ...fonts.semiBold, color: colors.background },
                styles.labelText,
            ]}>
            {title.toUpperCase()}
          </Text>
        </View>)}
      <ThemedTextWithBold style={styles.drawerText} fontDefault={fonts.regular} fontBold={fonts.bold} textContent={textContent}/>
    </View>);
};
const styles = StyleSheet.create({
    drawerTextContainer: {
        flex: 1,
    },
    drawerTextIconContainer: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        alignSelf: "flex-start",
        paddingVertical: 2,
        paddingHorizontal: 4,
        borderRadius: 2,
        marginBottom: 8,
    },
    drawerMenuLabelContainer: {
        flexDirection: "row",
        marginBottom: 8,
    },
    drawerText: {
        lineHeight: 20.8,
    },
    labelText: {
        fontSize: 12,
        letterSpacing: 1.02,
        lineHeight: 14.4,
    },
});
//# sourceMappingURL=DrawerText.js.map